var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personalCard"},[_c('div',{class:_vm.type == 'line' ? 'leftLine' : 'left'},[_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2),_vm._t("status")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }